import type Immutable from 'immutable';

import { getDragModifierKeys } from './dragModifierKeysSelector';
import { MODIFIER_KEYS } from './dragModifierKeysConstants';

/**
 * Whether Option/Alt is currently held, which copies the dragged content instead of moving it,
 * matching the legacy element drag path.
 */
export const isCopyDrag = (state: Immutable.Map<string, unknown>): boolean =>
    !!getDragModifierKeys(state).get(MODIFIER_KEYS.altKey);
